import React from 'react';
import { AssetDashboardKpis } from '../types';

interface Props {
  kpis: AssetDashboardKpis | null;
}

export const AssetsMetricsCards: React.FC<Props> = ({ kpis }) => {
  if (!kpis) return null;

  const cards = [
    {
      title: 'Toplam Varlik (Total Assets)',
      value: kpis.total_assets,
      sub: `${kpis.active_operational} Faal / Operasyonel`,
      color: '#0284c7',
      bg: '#f0f9ff',
    },
    {
      title: 'Hava Araci Filosu (Fleet)',
      value: kpis.aircraft_count,
      sub: 'EASA Ucusa Elverislilik Takibi',
      color: '#0d9488',
      bg: '#f0fdfa',
    },
    {
      title: 'Ekipman & Takim (Tools & GSE)',
      value: kpis.equipment_count + kpis.tools_count,
      sub: 'Yer Destek & Kalibrasyonlu Aletler',
      color: '#7c3aed',
      bg: '#faf5ff',
    },
    {
      title: 'Bakimda Olan (In Maintenance)',
      value: kpis.in_maintenance,
      sub: 'Part-145 Is Emirleri / AOG',
      color: kpis.in_maintenance > 0 ? '#ea580c' : '#16a34a',
      bg: kpis.in_maintenance > 0 ? '#fff7ed' : '#f0fdf4',
    },
    {
      title: 'Gecikmis Denetim & Muayene',
      value: kpis.overdue_inspections,
      sub: 'Ramp / Gunluk Kontroller',
      color: kpis.overdue_inspections > 0 ? '#dc2626' : '#16a34a',
      bg: kpis.overdue_inspections > 0 ? '#fef2f2' : '#f0fdf4',
    },
    {
      title: 'Gecikmis Kalibrasyon',
      value: kpis.overdue_calibrations,
      sub: 'ISO 17025 Gecerlilik',
      color: kpis.overdue_calibrations > 0 ? '#dc2626' : '#16a34a',
      bg: kpis.overdue_calibrations > 0 ? '#fef2f2' : '#f0fdf4',
    },
  ];

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
        gap: '16px',
        marginBottom: '24px',
      }}
    >
      {cards.map((c, idx) => (
        <div
          key={idx}
          style={{
            background: '#ffffff',
            border: '1px solid #e2e8f0',
            borderLeft: `4px solid ${c.color}`,
            borderRadius: '8px',
            padding: '16px 20px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
          }}
        >
          <div style={{ fontSize: '12px', fontWeight: 600, color: '#64748b', textTransform: 'uppercase' }}>
            {c.title}
          </div>
          <div style={{ fontSize: '26px', fontWeight: 700, color: c.color, margin: '6px 0 2px' }}>
            {c.value}
          </div>
          <div style={{ fontSize: '12px', color: '#64748b' }}>{c.sub}</div>
        </div>
      ))}
    </div>
  );
};
